































































































































































































































































































import moment from 'moment';
import XLSX from 'xlsx';
import { Component, Mixins, Vue, Watch } from 'vue-property-decorator';
import Summary from '../../core/components/Summary.vue';
import PageTitle from '../../core/components/PageTitle.vue';
import Combobox from '../../core/components/Combobox.vue';
import SimpleTable from '../../core/components/SimpleTable.vue';
import AlertBadge from '../../core/components/AlertBadge.vue';
import ModalInsuranceHarvest from '../../insurance/components/ModalInsuranceHarvest.vue';
import ModalCompanyHarvest from '../../insurance/components/ModalCompanyHarvest.vue';
import Button from '../../core/components/Button.vue';
import Input from '../../core/components/Input.vue';
import { MultipleSelect } from '../../core/components';
import ModalMachinesView from '../components/ModalMachinesView.vue';
import ModalLoadCalibrations from '../components/ModalLoadCalibrations.vue';
import DeleteConfirmation from '../../tracking/components/Geofences/DeleteConfirmation.vue';
import { CompanyStoreHelper, NotificationStoreHelper, RootStoreHelper } from '../../core/mixins';
import {
    splitStringByIndex,
    EventBus,
    TypeEventBus,
    sortObjectByPropertyName,
    getIdsFromList,
    getUniqueId,
    getItemFromLocalStorage,
    removeItemFromLocalStorage,
    getAlertColorByPriority,
    addItemToLocalStorage,
    getItemFromLocalStorageParsed,
    getTableItems,
    goToUrl
} from '../../core/utils/';
import { NAME_ROUTES } from '../../core/utils/name-routes';
import {
    getCompanyItemById,
    getDateFromTimestamp,
    matchedIndexIdInArray,
    removeItemsFromList,
    parseFloatNumber
} from '../../core/utils';
import { format } from 'highcharts';
import { InsuranceServices } from '../api/InsuranceServices';
import Axios from 'axios';
import { VehiclesEvent } from 'store';
import { getUrlVehicleConfiguration } from '../utils';

@Component({
    components: {
        Summary,
        Combobox,
        SimpleTable,
        Button,
        Input,
        DeleteConfirmation,
        PageTitle,
        ModalMachinesView,
        ModalLoadCalibrations,
        AlertBadge,
        MultipleSelect
    }
})
export default class InsuranceMachineView extends Mixins(CompanyStoreHelper, NotificationStoreHelper, RootStoreHelper) {
    summaryData: any = [];
    allItemsSowing: Array<object> = [];
    allItemsHarvest: Array<object> = [];
    savedFiltersSowing: Array<string> = [];
    savedFiltersHarvest: Array<string> = [];

    numberAlertsSowing: number = 0;
    numberAlertsHarvest: number = 0;
    hasParams: boolean = window.location.href.indexOf('?') !== -1 ? true : false;

    //Filters
    filtersCompanySelected: any | null = null;
    filtersInsuranceCarrierSelected: any | null = null;
    filtersStatusMachine: any | null = null;
    filtersStatusHarvest: any | null = null;
    filtersHarvest: any | null = null;

    filtersCompanySelectedRV: any = null;
    filtersInsuranceCarrierRV: any = null;
    filtersStatusMachineRV: any = null;
    filtersStatusHarvestRV: any = null;
    filtersHarvestRV: any = null;
    filtersZafraTypeSelected: any = null;
    filtersZafraYear: any = null;
    filtersZafraTypeRv: boolean = false;
    filtersZafraYearRv: boolean = false;
    panelSowing: number | null = null;
    panelHarvest: number | null = null;
    pendingCalibrationXlsx: boolean = false;

    viewHarvestDetail(item) {
        goToUrl(getUrlVehicleConfiguration(item['vehicle']['id'], item.farming.id, 1))
    }
    viewSowingDetail(item) {
        goToUrl(getUrlVehicleConfiguration(item['vehicle']['id'], item.farming.id, 0))
    }

    updateFiltersCompanySelected(value) {
        if (value !== null) {
            addItemToLocalStorage('mv_filters_asegurada', value);
        } else {
            removeItemFromLocalStorage('mv_filters_asegurada');
        }
        this.filtersCompanySelected = value;
    }
    updateFiltersCompanySelectedRV(value) {
        this.filtersCompanySelectedRV = value;
    }
    clearInsuranceCompanies() {
        this.filtersInsuranceCompaniesSelected = [];
        this.multipleInsuranceCompanySelector.clearOptionsSelected();
    }
    updateFiltersInsuranceCarrierSelected(value) {
        if (value !== null) {
            addItemToLocalStorage('mv_filters_aseguradora', value);
        } else {
            removeItemFromLocalStorage('mv_filters_aseguradora');
        }
        this.clearInsuranceCompanies();
        this.filtersInsuranceCarrierSelected = value;
        this.getItemsFromSowing();
        this.getItemsFromHarvest();
    }
    updateFiltersInsuranceCarrierRV(value) {
        this.filtersInsuranceCarrierRV = value;
    }
    updateFiltersStatusMachine(value) {
        this.filtersStatusMachine = value;
    }
    updateFiltersStatusMachineRV(value) {
        this.filtersStatusMachineRV = value;
    }
    updateFiltersStatusHarvest(value) {
        this.filtersStatusHarvest = value;
    }
    updateFiltersStatusHarvestRV(value) {
        this.filtersStatusHarvestRV = value;
    }
    updateFiltersHarvest(value) {
        this.filtersHarvest = value;
    }
    updateFiltersHarvestRV(value) {
        this.filtersHarvestRV = value;
    }
    updateSavedFiltersSowing(value){
        this.savedFiltersSowing = value
    }
    updateSavedFiltersHarvest(value){
        this.savedFiltersHarvest = value
    }

    //filters options
    optionsCompany: Array<object> = [];
    optionsInsuranceCompany: Array<object> = [];
    optionsFiltersMachineState: Array<object> = [];
    optionsState: Array<object> = [
        {
            id: 1,
            name: 'Activa',
            value: true
        },
        {
            id: 2,
            name: 'Inactiva',
            value: false
        }
    ];

    vehiclesPreview: Array<object> = [];
    itemsSowing: Array<object> = [];
    selectedSowing: Array<object> = [];
    itemsHarvest: Array<object> = [];
    selectedHarvest: Array<object> = [];
    searchSowingTable: string = '';
    searchHarvestTable: string = '';
    headersSowing: any = [
        {
            text: 'Empresa',
            value: 'company.name',
            sortable: true,
            width: '200px',
            filter: this.filtersByCompanySelected
        },
        {
            text: 'VIN',
            value: 'vehicle.vin',
            sortable: true
        },
        {
            text: 'Máquina',
            value: 'vehicle.description',
            sortable: true
        },
        {
            text: 'Has Zafra',
            value: 'sown_area',
            align: 'center',
            sortable: true
        },
        {
            text: 'Alertas',
            value: 'alerts',
            align: 'center',
            sortable: true
        },
        {
            text: 'Estado',
            value: 'state',
            filter: this.filterByMachineState,
            sortable: true
        },
        {
            text: 'Zafra',
            value: 'farming',
            sortable: true,
            formatter: this.getFarmingName,
            filter: this.filterByFarming,
            width: '200px'
        },
        {
            text: 'Acciones',
            value: 'actions',
            align: 'center',
            sortable: true
        },
        {
            text: '',
            value: 'harvest_year',
            align: ' d-none',
            sortable: true,
            class: 'hide-header',
            filter: this.filterByHarvestYear
        },
        {
            text: 'Empresa Aseguradora',
            value: 'insurance_company.id',
            class: 'hide-header',
            align: ' d-none',
            sortable: true,
            formatter: this.insuranceCompanyFormatter,
            filter: this.filterInsuranceCompany
        },
        {
            text: 'season',
            value: 'farming.season',
            sortable: false,
            class: 'hide-header',
            filter: this.filterFarmingsBySeason,
            align: ' d-none'
        },
        {
            text: 'Año',
            value: 'farming.year',
            sortable: false,
            class: 'hide-header',
            filter: this.filterFarmingsByYear,
            align: ' d-none'
        }
    ];
    headersHarvest: any = [
        {
            text: 'Empresa',
            value: 'company.name',
            width: '200px',
            filter: this.filtersByCompanySelected,
            sortable: true
        },
        {
            text: 'VIN',
            value: 'vehicle.vin',
            sortable: true
        },
        {
            text: 'Máquina',
            value: 'vehicle.description',
            sortable: true
        },
        {
            text: 'Ult. Calib',
            value: 'last_calibration',
            align: 'center',
            formatter: this.dateFormatter,
            sortable: true
        },
        {
            text: 'Has. Ult.Calib',
            value: 'harvested_area_since_calibration',
            formatter: this.parseValue,
            align: 'center',
            sortable: true
        },
        {
            text: '# Calibr',
            value: 'calibrations',
            align: 'center',
            sortable: true
        },
        {
            text: 'Calibrar',
            value: 'should_calibrate',
            class: 'highlight-column',
            align: 'center',
            sortable: true
        },
        {
            text: 'Ult. Lev Mapa',
            value: 'last_upload_map',
            align: 'center',
            class: 'highlight-column',
            formatter: this.dateFormatter,
            sortable: true
        },
        {
            text: '# Chacras',
            value: 'completed_ranches',
            align: 'center',
            sortable: true
        },
        {
            text: '# Has',
            value: 'harvested_area',
            align: 'center',
            sortable: true
        },
        {
            text: 'Lev. Mapa',
            value: 'should_upload_map',
            align: 'center',
            sortable: true
        },
        {
            text: 'Alertas',
            value: 'alerts',
            align: 'center',
            sortable: true
        },
        {
            text: 'Estado',
            value: 'state',
            filter: this.filterByMachineState,
            sortable: true
        },
        {
            text: 'Zafra',
            value: 'farming',
            formatter: this.getFarmingName,
            filter: this.filterByFarming,
            sortable: true,
            width: '200px'
        },
        {
            text: 'Acciones',
            value: 'actions',
            align: 'center',
            sortable: true
        },
        {
            text: 'season',
            value: 'farming.season',
            sortable: false,
            class: 'hide-header',
            filter: this.filterFarmingsBySeason,
            align: ' d-none'
        },
        {
            text: 'Año',
            value: 'farming.year',
            sortable: false,
            class: 'hide-header',
            filter: this.filterFarmingsByYear,
            align: ' d-none'
        },
        {
            text: '',
            value: 'harvest_year',
            align: ' d-none',
            sortable: true,
            class: 'hide-header',
            filter: this.filterByHarvestYear
        },
        {
            text: 'Empresa Aseguradora',
            value: 'insurance_company.id',
            sortable: true,
            class: 'hide-header',
            align: ' d-none',
            formatter: this.insuranceCompanyFormatter,
            filter: this.filterInsuranceCompany
        }
    ];
    pendingRequestTables: boolean = false;
    loadingOptionsCompany: boolean = false;
    visibleModalMachineView: boolean = false;
    visibleModalLoadCalibrations: boolean = false;
    sortBy: string[] = ['should_calibrate'];
    sortDesc: boolean[] = [true];
    defaultAlertsSowing = ['alerts'];
    defaultAlertsSowingDesc = [true];
    sortBySowing: string[] = this.defaultAlertsSowing;
    sortDescSowing: boolean[] = this.defaultAlertsSowingDesc;
    patchDataSowingDetail: object = {};
    yearsOptions: Array<object> = [];

    updateFiltersZafraType(value) {
        this.filtersZafraTypeSelected = value;
    }

    updateFiltersZafraTypeRV(value) {
        this.filtersZafraTypeRv = value;
    }

    updateFiltersZafraYear(value) {
        this.filtersZafraYear = value;
    }

    updateFiltersZafraYearRV(value) {
        this.filtersZafraYearRv = value;
    }

    openModalLoadCalibrationData() {
        this.visibilityModalLoadCalibrations(true);
    }

    visibilityModalMachines(value) {
        this.visibleModalMachineView = value;
        if (!value) {
            this.cancelLastReportToken();

            this.modalVehicles.clearLastReportInterval();
        }
    }

    visibilityModalLoadCalibrations(value) {
        this.visibleModalLoadCalibrations = value;
    }

    cancelLastReportToken() {
        if (this.cancelTokenLastReport) {
            this.cancelTokenLastReport.cancel();
            this.cancelTokenLastReport = null;
        }
    }

    filterInsuranceCompany(value) {
        return this.filtersInsuranceCarrierSelected == null
            ? true
            : value === this.filtersInsuranceCarrierSelected['id'];
    }

    filtersByCompanySelected(companyName) {
        /* Filtro por empresa aseguradora */
        if (this.filtersInsuranceCompaniesSelected.length == 0) {
            return true;
        }
        let indexCompanyNameInFilteredOptions = this.filtersInsuranceCompaniesSelected.findIndex(
            item => item['name'] === companyName
        );
        if (indexCompanyNameInFilteredOptions !== -1) {
            return this.filtersInsuranceCompaniesSelected[indexCompanyNameInFilteredOptions];
        }
    }

    filterFarmingsBySeason(value) {
        if (this.filtersZafraTypeSelected == null) {
            return true;
        } else {
            return value === this.filtersZafraTypeSelected['value'];
        }
    }

    filterFarmingsByYear(value) {
        if (this.filtersZafraYear == null) {
            return true;
        } else {
            return value === this.filtersZafraYear['value'];
        }
    }

    

    updateSummaryData(sowingItems: Array<object> | null, harvestItems: Array<object> | null) {
        let itemsSowing = sowingItems ? sowingItems : this.itemsSowing;
        let itemsHarvest = harvestItems ? harvestItems : this.itemsHarvest;
        let no_empresas: number[] = [],
            no_sembradoras: number[] = [],
            homologationsList: any = [],
            homologationsPendingList: any = [],
            no_marcas_diferentes = -1, //pending
            no_cosechadoras: number[] = [],
            modelos_diferentes = -1, //pending
            maquinas_calibracion = 0,
            maquinas_lev_mapa = 0,
            activaciones_faltantes: number = 0,
            has_siembra: number = 0,
            has_cosecha: number = 0;

        //estado máquina values
        let maquinas_estado: Array<object> = [];
        this.optionsFiltersMachineState = [];

        this.numberAlertsSowing = 0;
        this.numberAlertsHarvest = 0;
        //loop over sembradoras table
        for (let a = 0; a < itemsSowing.length; a++) {
            const sowing = itemsSowing[a];

            if (sowing['alert_priority'] >= 2) {
                this.numberAlertsSowing++;
            }

            if (sowing['company'] && sowing['company']['id']) {
                no_empresas.push(sowing['company']['id']);
            }
            if (sowing['vehicle'] && sowing['vehicle']['id']) {
                no_sembradoras.push(sowing['vehicle']['id']);
            }
            if (sowing['vehicle'] && sowing['vehicle']['activated']) {
                if (sowing['vehicle']['activated'] == false) {
                    activaciones_faltantes++;
                }
            }
            if (sowing['sown_area']) {
                has_siembra = has_siembra + sowing['sown_area'];
            }
            if (sowing['state']) {
                maquinas_estado.push(sowing['state']);
            }
            if (sowing['state'] === 'Homologado') {
                this.pushIfNoExists(homologationsList, sowing['vehicle']['id']);
            }
            if (sowing['state'] === 'No homologado') {
                this.pushIfNoExists(homologationsPendingList, sowing['vehicle']['id']);
            }
        }

        //loop over cosechadoras table
        for (let b = 0; b < itemsHarvest.length; b++) {
            const harvest = itemsHarvest[b];
            if (harvest['alert_priority'] >= 2) {
                this.numberAlertsHarvest++;
            }
            if (harvest['company'] && harvest['company']['id']) {
                no_empresas.push(harvest['company']['id']);
            }
            if (harvest['vehicle'] && harvest['vehicle']['id']) {
                no_cosechadoras.push(harvest['vehicle']['id']);
            }
            if (harvest['vehicle'] && harvest['vehicle']['activated']) {
                if (harvest['vehicle']['activated'] == false) {
                    activaciones_faltantes++;
                }
            }
            if (harvest['harvested_area']) {
                has_cosecha = has_cosecha + harvest['harvested_area'];
            }
            if (harvest['should_calibrate'] == true) {
                maquinas_calibracion++;
            }
            if (harvest['should_upload_map'] == true) {
                maquinas_lev_mapa++;
            }
            if (harvest['state']) {
                maquinas_estado.push(harvest['state']);
            }
            if (harvest['state'] === 'Homologado') {
                this.pushIfNoExists(homologationsList, harvest['vehicle']['id']);
            }
            if (harvest['state'] === 'No homologado') {
                this.pushIfNoExists(homologationsPendingList, harvest['vehicle']['id']);
            }
        }

        maquinas_estado = this.removeDuplicatedFromObject(maquinas_estado);
        for (let index = 0; index < maquinas_estado.length; index++) {
            let value = maquinas_estado[index];
            maquinas_estado[index] = {
                id: index,
                name: value
            };
        }
        this.optionsFiltersMachineState = maquinas_estado;

        this.setSummaryData(
            this.removeDuplicatedFromObject(no_empresas).length,
            this.removeDuplicatedFromObject(no_sembradoras).length,
            homologationsList.length,
            no_marcas_diferentes,
            activaciones_faltantes,
            this.removeDuplicatedFromObject(no_cosechadoras).length,
            homologationsPendingList.length,
            modelos_diferentes,
            maquinas_calibracion,
            maquinas_lev_mapa,
            has_siembra,
            has_cosecha
        );
    }

    pushIfNoExists(list, item) {
        let existIndexInList = list.findIndex(it => it == item);
        if (existIndexInList == -1) {
            list.push(item);
        }
    }
    removeDuplicatedFromObject(object) {
        let uniqueObject = object.filter(function(item, pos) {
            return object.indexOf(item) == pos;
        });

        return uniqueObject;
    }

    setSummaryData(
        no_empresas,
        no_sembradoras,
        no_homologaciones,
        no_marcas_diferentes,
        activaciones_faltantes,
        no_cosechadoras,
        homologaciones_faltantes,
        modelos_diferentes,
        maquinas_calibracion,
        maquinas_lev_mapa,
        has_siembra,
        has_cosecha
    ) {
        this.summaryData = [
            {
                text: '# Empresas',
                value: no_empresas
            },
            {
                text: '# Sembradoras',
                value: no_sembradoras
            },
            {
                text: '# Homologaciones',
                value: no_homologaciones
            },
            {
                text: '# Marcas diferentes',
                value: no_marcas_diferentes
            },
            {
                text: 'Activaciones Faltantes',
                value: activaciones_faltantes
            },
            {
                text: '# Cosechadoras',
                value: no_cosechadoras
            },
            {
                text: '# Homologaciones Faltantes',
                value: homologaciones_faltantes
            },
            {
                text: '# Modelos diferentes',
                value: modelos_diferentes
            },
            {
                text: 'Máquinas para calibración',
                value: maquinas_calibracion
            },
            {
                text: 'Máquinas para Lev. Mapa',
                value: maquinas_lev_mapa
            },
            {
                text: '# Has Siembra',
                value: parseFloatNumber(has_siembra)
            },
            {
                text: '# Has Cosecha',
                value: parseFloatNumber(has_cosecha)
            }
        ];
    }

    filteredSowingItems: Array<object> | null = null;
    filteredHarvestItems: Array<object> | null = null;
    loadingVehicles: boolean = false;
    cancelTokenLastReport: any = null;
    filtersInsuranceCompaniesSelected: Array<object>[] = [];

    filtersSelectInsuranceCompany(itemToAdd) {
        this.filtersInsuranceCompaniesSelected.push(itemToAdd);
    }

    filtersRemoveInsuranceCompany(itemToRemove) {
        this.filtersInsuranceCompaniesSelected = this.filtersInsuranceCompaniesSelected.filter(
            item => item['id'] !== itemToRemove.id
        );
    }

    get getItemsSowing(){
        return getTableItems(this.allItemsSowing, this.savedFiltersSowing)
    }

    get getItemsHarvest(){
        return getTableItems(this.allItemsHarvest, this.savedFiltersHarvest)
    }

    get getOptionsCompany() {
        if (this.filtersInsuranceCarrierSelected == null) {
            return [];
        }
        return this.filtersInsuranceCarrierSelected['secured_companies'];
    }

    @Watch('panelHarvest')
    observablePanelHarvest(value) {
        if (value == 1) {
            this.getItemsFromHarvest();
        }
    }

    @Watch('panelSowing')
    observablePanelSowing(value) {
        if (value == 0) {
            this.getItemsFromSowing();
        }
    }

    @Watch('filteredSowingItems')
    @Watch('filteredHarvestItems')
    observableFilteredItems() {
        this.updateSummaryData(this.filteredSowingItems, this.filteredHarvestItems);
    }

    get placeholderInsuranceCompany() {
        return this.filtersInsuranceCarrierSelected == null ? 'Seleccione una aseguradora' : 'Seleccionar';
    }

    get existFilteredSowingItems() {
        return this.filteredSowingItems !== null ? true : false;
    }

    get existFilteredHarvestItems() {
        return this.filteredHarvestItems !== null ? true : false;
    }

    get existAnyFilterApplied() {
        if (
            this.filtersInsuranceCarrierSelected !== null ||
            this.filtersCompanySelected !== null ||
            this.filtersStatusMachine !== null ||
            this.filtersStatusHarvest !== null ||
            this.filtersHarvest !== null ||
            this.filtersZafraTypeSelected !== null ||
            this.filtersZafraYear !== null
        ) {
            return true;
        } else {
            this.updateSummaryData(this.itemsSowing, this.itemsHarvest);
            return false;
        }
    }

    @Watch('filtersInsuranceCarrierSelected')
    observableInsuranceCompanyChange(value) {
        this.setCompanyOptions(value);
    }

    @Watch('$_getInsuranceProperties', { immediate: true, deep: true })
    observableProperties() {
        this.assignPropertiesData();
    }

    get modalVehicles(): HTMLFormElement {
        return this.$refs.modalMachineView as HTMLFormElement;
    }

    get multipleInsuranceCompanySelector(): HTMLFormElement {
        return this.$refs.mwCompany as HTMLFormElement;
    }

    mounted() {
        EventBus.$on(TypeEventBus.REFRESH_MACHINE_VIEW, () => {
            this.getItemsFromHarvest();
            this.getItemsFromSowing();
        });

        this.$nextTick(() => {
            this.assignPropertiesData();
            if (getItemFromLocalStorage('mv_filters_aseguradora') !== null) {
                this.updateFiltersInsuranceCarrierSelected(getItemFromLocalStorageParsed('mv_filters_aseguradora'));
            }
            if (getItemFromLocalStorage('mv_filters_asegurada') !== null) {
                this.updateFiltersCompanySelected(getItemFromLocalStorageParsed('mv_filters_asegurada'));
            }
        });

        this.updateFiltersStatusHarvest(this.optionsState[0]);
    }

    unforceLevMap(item) {
        let self = this;
        if (item['vehicle'] && item['vehicle']['id']) {
            this.$set(item, 'updating', true);
            let data = {
                vehicle_id: item['vehicle']['id'],
                action_type: 1
            };
            InsuranceServices.acknowledgeAction(data)
                .then(res => {
                    for (let i = 0; i < self.itemsHarvest.length; i++) {
                        let farming = self.itemsHarvest[i];
                        if (farming['vehicle'] && farming['vehicle']['id'] === item['vehicle']['id']) {
                            self.$set(farming, 'updating', false);
                            self.$set(farming, 'force_upload_map', false);
                            self.$set(farming, 'should_upload_map', false);
                        }
                    }
                    self.$_successDeleteRecipients(res['data']['message']);
                })
                .catch(error => {
                    if (error && error.response && error.response.status !== 200) {
                        self.$set(item, 'updating', false);
                        self.$set(item, 'force_upload_map', true);
                        self.$set(item, 'should_upload_map', true);
                    }
                });
        }
    }

    uncalibrateVehicle(item) {
        let self = this;
        if (item['vehicle'] && item['vehicle']['id']) {
            this.$set(item, 'pending', true);
            let data = {
                vehicle_id: item['vehicle']['id'],
                action_type: 0
            };
            InsuranceServices.acknowledgeAction(data)
                .then(res => {
                    for (let i = 0; i < self.itemsHarvest.length; i++) {
                        let farming = self.itemsHarvest[i];
                        if (farming['vehicle'] && farming['vehicle']['id'] === item['vehicle']['id']) {
                            self.$set(farming, 'pending', false);
                            self.$set(farming, 'force_calibrate', false);
                            self.$set(farming, 'should_calibrate', false);
                        }
                    }
                    self.$_successDeleteRecipients(res['data']['message']);
                    // self.$set(item, 'should_calibrate', true);
                })
                .catch(error => {
                    if (error && error.response && error.response.status !== 200) {
                        self.$set(item, 'pending', false);
                        self.$set(item, 'force_calibrate', false);
                        self.$set(item, 'should_calibrate', false);
                    }
                });
        }
    }

    assignPropertiesData() {
        this.setInsuranceCompanies();
        this.updateYearsOptions();
    }

    setInsuranceCompanies() {
        let insuranceCompanies = this.$_getInsuranceProperties['insurance_companies'];
        this.optionsInsuranceCompany = insuranceCompanies;
    }

    setCompanyOptions(insuranceSelected) {
        this.loadingOptionsCompany = true;
        let companyOptions: Array<object> = [];
        if (insuranceSelected !== null) {
            let companyIndex = this.optionsInsuranceCompany.findIndex(
                item => item['company'] === insuranceSelected['company']
            );

            if (companyIndex !== -1) {
                companyOptions = this.optionsInsuranceCompany[companyIndex]['secured_companies'];
            }
        }
        this.optionsCompany = companyOptions;
        this.loadingOptionsCompany = false;
    }

    filteredItemsSowing(filteredItems) {
        let self = this;
        self.filteredSowingItems = filteredItems;
    }

    filteredItemsHarvest(filteredItems) {
        let self = this;
        self.filteredHarvestItems = filteredItems;
    }

    markToCalibrate(item) {
        let self = this;
        if (item['vehicle'] && item['vehicle']['id']) {
            this.$set(item, 'pending', true);
            let data = {
                vehicle_id: item['vehicle']['id'],
                action_type: 0
            };
            InsuranceServices.postVehicleAction(data)
                .then(res => {
                    for (let i = 0; i < self.itemsHarvest.length; i++) {
                        let farming = self.itemsHarvest[i];
                        if (farming['vehicle'] && farming['vehicle']['id'] === item['vehicle']['id']) {
                            self.$set(farming, 'pending', false);
                            self.$set(farming, 'force_calibrate', true);
                            self.$set(farming, 'should_calibrate', true);
                        }
                    }
                    self.$set(item, 'pending', false);
                    self.$_successDeleteRecipients(res['message']);
                    // self.$set(item, 'should_calibrate', true);
                })
                .catch(error => {
                    if (error && error.response && error.response.status !== 200) {
                        self.$_showHistoricalError('No se pudo marcar para calibrar. Intente nuevamente');
                        self.$set(item, 'pending', false);
                    }
                });
        }
    }

    markToLevMap(item) {
        let self = this;
        if (item['vehicle'] && item['vehicle']['id']) {
            this.$set(item, 'updating', true);
            let data = {
                vehicle_id: item['vehicle']['id'],
                action_type: 1
            };
            InsuranceServices.postVehicleAction(data)
                .then(res => {
                    for (let i = 0; i < self.itemsHarvest.length; i++) {
                        let farming = self.itemsHarvest[i];
                        if (farming['vehicle'] && farming['vehicle']['id'] === item['vehicle']['id']) {
                            self.$set(farming, 'updating', false);
                            self.$set(farming, 'force_upload_map', true);
                            self.$set(farming, 'should_upload_map', true);
                        }
                    }
                    self.$_successDeleteRecipients(res['message']);
                    // self.handleRefresh();
                    // self.$set(item, 'should_upload_map', true);
                })
                .catch(error => {
                    if (error && error.response && error.response.status !== 200) {
                        self.$_showHistoricalError('No se pudo marcar para levantada de Mapa. Intente nuevamente');
                        self.$set(item, 'updating', false);
                        self.$set(item, 'force_upload_map', false);
                        self.$set(item, 'should_upload_map', false);
                    }
                });
        }
    }

    handleRefresh() {
        window.location.reload();
    }

    reloadMachineView() {
        this.getItemsFromHarvest();
        this.getItemsFromSowing();
    }

    resetSummaryData() {
        this.summaryData = [];
    }

    getSearchParams(summaryType) {
        return {
            summary_type: summaryType,
            insurance_company:
                this.filtersInsuranceCarrierSelected !== null ? this.filtersInsuranceCarrierSelected['id'] : null
        };
    }

    getItemsFromHarvest() {
        this.resetSummaryData();
        this.pendingRequestTables = true;
        let token = Axios.CancelToken.source();
        let self = this;
        let searchParams = this.getSearchParams(1);
        InsuranceServices.getVehiclesSummary(token, searchParams)
            .then(res => {
                this.setHarvestResponse(res);
            })
            .catch(() => {
                self.pendingRequestTables = false;
            });
    }

    setHarvestResponse(res) {
        this.assignItemsHarvest([]);
        removeItemFromLocalStorage('mv_harvest_res');

        setTimeout(() => {
            this.assignItemsHarvest(res['harvest']);
            this.updateSummaryData(null, null);
            this.updateYearsOptions();
            this.pendingRequestTables = false;
        }, 0);
    }

    setSowingResponse(res) {
        this.assignItemsSowing([]);
        removeItemFromLocalStorage('mv_sowing_res');

        setTimeout(() => {
            this.sortBySowing = this.defaultAlertsSowing;
            this.sortDescSowing = this.defaultAlertsSowingDesc;
            this.assignItemsSowing(res['sowing']);
            this.updateSummaryData(null, null);
            this.updateYearsOptions();
            this.pendingRequestTables = false;
        }, 0);
    }

    getItemsFromSowing() {
        this.resetSummaryData();
        this.pendingRequestTables = true;
        let token = Axios.CancelToken.source();
        let self = this;
        let searchParams = this.getSearchParams(2);
        InsuranceServices.getVehiclesSummary(token, searchParams)
            .then(res => {
                self.setSowingResponse(res);
            })
            .catch(() => {
                self.pendingRequestTables = false;
            });
    }

    assignItemsSowing(items) {
        this.itemsSowing = this.getItemsWithFormattedAlerts(items);
        this.allItemsSowing = this.itemsSowing
    }

    assignItemsHarvest(items) {
        this.itemsHarvest = this.getItemsWithFormattedAlerts(items);
        this.allItemsHarvest = this.itemsHarvest
    }

    getItemsWithFormattedAlerts(items) {
        let self = this;
        items.forEach((item, index) => {
            self.$set(item, 'id', getUniqueId());
            let alertList = item['alerts'];
            let vehicleVin = parseInt(item['vehicle']['vin']);
            let vehicleVinValue = isNaN(vehicleVin) ? -1 : vehicleVin;
            self.$set(item['vehicle'], 'vin', vehicleVinValue);
            if (item['alerts'] && item['alerts']['msgs'] && item['alerts']['msgs'].length !== 0) {
                alertList = item['alerts']['msgs'];
            }
            self.$set(item, 'alerts', self.formatAlert(alertList, item['alert_priority']));
        });
        return items;
    }

    updateSearchSowing(value) {
        this.searchSowingTable = value;
    }
    updateSearchHarvest(value) {
        this.searchHarvestTable = value;
    }

    dateFormatter(value) {
        let date = moment(value);
        if (!date.isValid()) {
            return '-';
        } else {
            return getDateFromTimestamp(value);
        }
    }

    parseValue(value){
        return parseFloatNumber(value)
    }

    formatAlert(alerts: string[], alertPriority: number) {
        let msgs: string[] = [];
        let self = this;

        if (alertPriority == 0) {
            return {
                msgs: msgs,
                priority: 0
            };
        } else {
            let alertColor = getAlertColorByPriority(alertPriority);
            for (let index = 0; index < alerts.length; index++) {
                let alert = alerts[index];
                if (alert.indexOf('<br>') == -1) {
                    alert += '<br>';
                }
                msgs.push(alert);
            }

            return {
                msgs: msgs,
                bgColor: alertColor,
                textColor: alertPriority == 1 ? '#000000' : '#ffffff',
                priority: alertPriority
            };
        }
    }

    viewMap(userAction) {
        let self = this;

        if (userAction) {
            this.cancelTokenLastReport = Axios.CancelToken.source();
        } else {
            if (!this.visibleModalMachineView) {
                this.cancelLastReportToken();
            }
        }

        this.loadingVehicles = true;
        let itemsSowing: any =
            this.selectedSowing.length > 0
                ? this.selectedSowing
                : this.existFilteredSowingItems
                ? this.filteredSowingItems
                : this.itemsSowing;
        let itemsHarvest: any =
            this.selectedHarvest.length > 0
                ? this.selectedHarvest
                : this.existFilteredHarvestItems
                ? this.filteredHarvestItems
                : this.itemsHarvest;
        let vehiclesList = [...itemsSowing, ...itemsHarvest];
        let vehiclesIds: number[] = [];
        vehiclesList.forEach(item => {
            if (item['vehicle'] && item['vehicle']['id']) {
                if (vehiclesIds.indexOf(item['vehicle']['id']) == -1) {
                    vehiclesIds.push(item['vehicle']['id']);
                }
            }
        });

        // this.vehiclesPreview = [];
        InsuranceServices.getVehiclesLastReport(vehiclesIds, this.cancelTokenLastReport)
            .then(res => {
                this.visibilityModalMachines(true);
                //  if(this.visibleModalMachineView){
                //      this.modalVehicles.clearMarkers();
                //  }

                setTimeout(() => {
                    self.modalVehicles.setMarkers(res);
                }, 600);

                // this.vehiclesPreview = res;

                this.loadingVehicles = false;
            })
            .catch(err => {
                this.loadingVehicles = false;
            });
    }

    updateSelectedHarvest(value) {
        this.selectedHarvest = value;
    }

    updateSelectedSowing(value) {
        this.selectedSowing = value;
    }

    filterByFarming(farming) {
        return this.filtersStatusHarvest == null ? true : farming['active'] == this.filtersStatusHarvest['value'];
    }

    filterByMachineState(state) {
        return this.filtersStatusMachine == null ? true : state === this.filtersStatusMachine['name'];
    }

    getFarmingName(farming) {
        return farming['name'];
    }

    filterByHarvestYear(value) {
        if (this.filtersHarvest == null) {
            return true;
        } else {
            return value == this.filtersHarvest['value'];
        }
    }

    vehicleFormatter(vehicle) {
        return vehicle['vin'] + ' - ' + vehicle['description'];
    }

    updateYearsOptions() {
        let yearsOptions: any = [];

        for (let i = 0; i < this.itemsSowing.length; i++) {
            let year = this.itemsSowing[i]['farming']['year'];
            pushYear(year);
        }
        for (let b = 0; b < this.itemsHarvest.length; b++) {
            let year = this.itemsHarvest[b]['farming']['year'];
            pushYear(year);
        }

        function pushYear(year) {
            let indexYear = yearsOptions.findIndex(item => item['value'] === year);
            if (indexYear == -1) {
                yearsOptions.push({
                    value: year,
                    id: yearsOptions.length + 1
                });
            }
        }
        if (yearsOptions.length > 0) {
            yearsOptions = yearsOptions.sort(sortObjectByPropertyName('value'));
        }

        this.yearsOptions = yearsOptions;
    }

    insuranceCompanyFormatter(companyId) {
        let allInsuranceCompanies = this.$_getInsuranceProperties['insurance_companies'];
        if (allInsuranceCompanies) {
            let companyIndex = allInsuranceCompanies.findIndex(item => item['id'] === companyId);
            if (companyIndex !== -1) {
                return allInsuranceCompanies[companyIndex]['name'];
            }
        }
    }

    

    backToInsurance() {
        this.$router.push(NAME_ROUTES.INSURANCE.path);
    }
}
